<template>
<div>
  <div class="question">{{question.question_text}}</div>
  <div class="question-group">
    <span v-for="n in 7"
      :key="n" class="radio"
      @click="setAnswer(n)"
      style="cursor: pointer; flex: 1">
      <i class="material-icons" v-if="question.answer !== n">panorama_fish_eye</i>
      <h-icon v-ripple="{ center: true }" v-if="question.answer === n" color="blue">radio_button_checked</h-icon>
      <span>{{ n }}</span>
      <span v-if="n == 7" class="hide-at-xs">Strongly Agree</span>
      <span v-if="n == 1" class="hide-at-xs">Strongly Disagree</span>
    </span>
  </div>
  <div class="rating">
      <span class="show-at-xs">Strongly Disagree</span>
      <span class="show-at-xs">Strongly Agree</span>
  </div>
</div>
</template>

<script>
export default {
  props: ["question"],
  methods: {
    setAnswer(n) {
      this.question.answer = n;
      this.$emit("answerChanged", this.question);
    }
  }
};
</script>

<style>
.rating {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-transform: uppercase;
  font-size: 10px;
  letter-spacing: 1px;
  padding-bottom: 15px;
}

.radio {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.question-group {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
  margin-top: 20px;
}
</style>
